import React from "react";
import { lighten, Menu, MenuItem } from "@mui/material";
// i18n
import { useTranslation } from "react-i18next";

// Constants
import { terracotta } from "Constants/ColourConstants";

const styles = {
  menuItem: {
    "&.Mui-selected": {
      backgroundColor: lighten(terracotta, 0.7),
    },
    "&.Mui-selected:hover": {
      backgroundColor: lighten(terracotta, 0.5),
    },
  },
};

export const LanguageSelector = (props) => {
  const { position, open, onClose, anchorEl } = props;
  const { i18n } = useTranslation();

  const handleChangeLanguage = (lang) => {
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
    handleClose();
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={
          position === "left"
            ? { vertical: "bottom", horizontal: "left" }
            : { vertical: "top", horizontal: "center" }
        }
        transformOrigin={
          position === "left"
            ? { vertical: "center", horizontal: "right" }
            : { vertical: "bottom", horizontal: "center" }
        }
      >
        <MenuItem
          sx={styles.menuItem}
          selected={i18n.language === "en"}
          onClick={() => handleChangeLanguage("en")}
        >
          English
        </MenuItem>
        <MenuItem
          sx={styles.menuItem}
          selected={i18n.language === "fr"}
          onClick={() => handleChangeLanguage("fr")}
        >
          Français
        </MenuItem>
      </Menu>
    </>
  );
};
